module.exports = __webpack_public_path__ + "img/instagram.9a8f106e.png";